export default {"src":"/_next/static/media/sports-together.2fd6c8ea.svg","height":266,"width":327,"blurWidth":0,"blurHeight":0};